module.exports = __webpack_public_path__ + "static/media/constLogo2.8480fafc.png";